import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import Headers from "../../components/Headers";
import * as yup from "yup";
import { Field, Formik } from "formik";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import axios from "axios";
import { useLoginStore } from "../../Utils/Store";
import { useNavigate } from "react-router-dom";

const ChangePass = () => {
  const isLogin = useLoginStore((state) => state.isLogin);

  const loginStore = useLoginStore();
  const navigate = useNavigate();

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleShowCurrent = () => setShowCurrent((show) => !show);
  const handleShowNew = () => setShowNew((show) => !show);
  const handleShowConfirm = () => setShowConfirm((show) => !show);

  const { id } = isLogin;

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const handleLogout = () => {
    loginStore.userLogout();
    navigate("/");
  };

  const checkoutSchema = yup.object().shape({
    currentPassword: yup.string().required("Current password is required"),
    newPassword: yup
      .string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
        "Password must contain letters and numbers"
      ),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  return (
    <Box m="20px">
      <Headers title="Change password" />
      <Formik
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          try {
            const { currentPassword, newPassword, confirmPassword } = values;

            const updatedData = {
              currentPassword,
              newPassword,
              confirmPassword,
            };

            const response = await axios.post(
              process.env.REACT_APP_UPDATE_PASS + `/${isLogin.id}`,
              updatedData
            );
            setSubmitting(false);
            alert("Password change successfully! Please re-login");
            resetForm();
            handleLogout();
          } catch (error) {
            alert("Current password is incorrect.");
            resetForm();
          }
        }}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box height="70vh" display="flex" justifyContent="center">
              <Box width="50vh">
                <Box sx={{ my: "10px" }}>
                  <InputLabel htmlFor="outlined-adornment-password">
                    Current Password
                  </InputLabel>
                  <Field name="currentPassword">
                    {({ field, meta }) => (
                      <div>
                        <OutlinedInput
                          fullWidth
                          type={showCurrent ? "text" : "password"}
                          id="outlined-adornment-password"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleShowCurrent}
                                edge="end"
                              >
                                {showCurrent ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          {...field}
                          onBlur={handleBlur}
                          error={meta.touched && !!meta.error}
                          value={values.currentPassword}
                        />
                        {meta.touched && meta.error && (
                          <FormHelperText error>{meta.error}</FormHelperText>
                        )}
                      </div>
                    )}
                  </Field>
                </Box>

                <Box sx={{ my: "10px" }}>
                  <InputLabel htmlFor="outlined-adornment-password">
                    New Password
                  </InputLabel>
                  <Field name="newPassword">
                    {({ field, meta }) => (
                      <div>
                        <OutlinedInput
                          fullWidth
                          type={showNew ? "text" : "password"}
                          id="outlined-adornment-password"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleShowNew}
                                edge="end"
                              >
                                {showNew ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                          {...field}
                          onBlur={handleBlur}
                          error={meta.touched && !!meta.error}
                          value={values.newPassword}
                        />
                        {meta.touched && meta.error && (
                          <FormHelperText error>{meta.error}</FormHelperText>
                        )}
                      </div>
                    )}
                  </Field>
                </Box>
                <Box sx={{ my: "10px" }}>
                  <InputLabel htmlFor="outlined-adornment-password">
                    Confirm Password
                  </InputLabel>
                  <Field name="confirmPassword">
                    {({ field, meta }) => (
                      <div>
                        <OutlinedInput
                          fullWidth
                          type={showConfirm ? "text" : "password"}
                          id="outlined-adornment-password"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleShowConfirm}
                                edge="end"
                              >
                                {showConfirm ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          {...field}
                          onBlur={handleBlur}
                          error={meta.touched && !!meta.error}
                          value={values.confirmPassword}
                        />
                        {meta.touched && meta.error && (
                          <FormHelperText error>{meta.error}</FormHelperText>
                        )}
                      </div>
                    )}
                  </Field>
                </Box>

                <Box display="flex" justifyContent="end" mt="20px">
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    disabled={isSubmitting}
                    fullWidth
                  >
                    Change Password
                  </Button>
                </Box>
              </Box>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default ChangePass;
